import { AfterViewInit, Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { SharedModule } from '../SharedModule';
import { ResourceComponent } from './resource/resource.component';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResourcesService } from '../../services/resources.service';
import { HttpClientModule } from '@angular/common/http';
import { SowService } from '../../services/sow.service';
import { SowComponent } from './sow/sow.component';
import { ManualTSService } from '../../services/manualts.service';
import { ManualTimeSheetComponent } from './manual-time-sheet/manual-time-sheet.component';
import { ForecastComponent } from './forecast/forecast.component';
import { ForecastService } from '../../services/forecast.service';
import { ReceiptsService } from '../../services/receipts.service';
import { ReceiptsComponent } from './receipts/receipts.component';
import { SecurityService } from '../../services/security';
import { SpinnerService } from '../generic/spinner/spinner.service';
import { DataURItoBlob } from '../../utils/file.service';

@Component({
  selector: 'app-data-management',
  standalone: true,
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './data-management.component.html',
  styleUrls: ['./data-management.component.css']
})
export class DataManagementComponent implements OnInit, AfterViewInit {
  user !: string;
  name !: string;

  resourceList: any = [] ;
  sowList: any = [] ;
  manualTSList: any = [] ;
  forecastList: any = [] ;
  receiptsList: any = [] ;
  totalRecords: number = 0;
  loading: boolean = true;
  search: any = {pageIndex: 0, pageSize: 10};
  searchSow: any = {pageIndex: 0, pageSize: 10};
  searchManualTS: any = {pageIndex: 0, pageSize: 10};
  searchForecast: any = {pageIndex: 0, pageSize: 10};
  searchReceipts: any = {pageIndex: 0, pageSize: 10};
  selectedItem: any = {};
  selectedItemSow: any = {};
  totalRecordsSow: number = 0;
  selectedItemManualTS: any = {};
  totalRecordsManualTS: number = 0;
  selectedItemForecast: any = {};
  totalRecordsForecast: number = 0;
  selectedItemReceipts: any = {};
  totalRecordsReceipts: number = 0;
  permissions: any = [];
  edit: number = 0;

  constructor(
    private __dialogService : DialogService,
    private __resourcesService : ResourcesService,
    private __sowService: SowService,
    private __manualTSService: ManualTSService,
    private __forecastService: ForecastService,
    private __receiptsService: ReceiptsService,
    private __securityService: SecurityService,
    private __spinnerService: SpinnerService,
  ) { }

  ngOnInit(): void {
    let usEnc = localStorage.getItem('user');
    this.name = localStorage.getItem('name')!;
    if (usEnc != null && usEnc.length > 0 && sessionStorage.getItem('profile') == 'undefined') {
      const param = { username: usEnc, "loginType": 1 };
      this.__securityService.authentication(param).subscribe((data: any) => {
        if (data.an_resultado === 1) {
          this.user = data.res_obj_login.username;
        }
      });
    }
    if ((''+sessionStorage.getItem('profile'))?.length > 0) {
      this.permissions = JSON.parse(''+sessionStorage.getItem('permissions')).roles;
      this.permissions.forEach((e: any) => {
        if (e.optionKey == 'menu_datamanagement') {
          this.edit = +e.flgEdit;
        }
      });
    }
    this.findListResources();
    this.findListSow();
    this.findListManualTimeSheet();
    this.findListForecast();
    this.findListReceipts();
  }

  onAddNewRrc() {
    let confirm = this.__dialogService.open(ResourceComponent, {
      width: '60%',
      header: 'New Resource',
      dismissableMask: false,
      closable: true,
      data: {
        item: {}
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      if (resp?.accion === 'success') {
        this.findListResources();
      }
    });
  }

  onEditNewRrc() {
    if (this.isEmpty(this.selectedItem)) {
      return;
    }
    let confirm = this.__dialogService.open(ResourceComponent, {
      width: '60%',
      header: 'Edit Resource',
      dismissableMask: false,
      closable: true,
      data: {
        item: this.selectedItem
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      this.selectedItem = {};
      this.findListResources();
    });
  }

  onPageChange(event: any) {
    this.search.pageIndex = event.first / event.rows;
    this.search.pageSize = event.rows;
    this.findListResources();
  }

  findListResources() {
    this.loading = true;
    this.__spinnerService.show({ type: 'dark' });
    this.resourceList = [];
    let param = {
      pageSize: this.search.pageSize,
      pageIndex: this.search.pageIndex,
      filter: this.search.filter !== null && this.search.filter !== undefined ? this.search.filter : ''
    }

    this.__resourcesService.getListResources(param).subscribe((resp: any) => {
      this.resourceList = resp.listResource;
      this.totalRecords = resp.an_total;
      this.loading = false;
      this.__spinnerService.close();
    });
  }

  onInputChange(event: any) {
    this.search.pageIndex = 0;
    this.search.pageSize = 10;
    this.findListResources();
  }

  selected(item: any) {
    this.selectedItem = item;
  }

  findListSow() {
    this.loading = true;
    this.__spinnerService.show({ type: 'dark' });
    this.sowList = [];
    let param = {
      pageSize: this.searchSow.pageSize,
      pageIndex: this.searchSow.pageIndex,
      filter: this.searchSow.filter !== null && this.searchSow.filter !== undefined ? this.searchSow.filter : ''
    }

    this.__sowService.getListSow(param).subscribe((resp: any) => {
      this.sowList = resp.listSow;
      this.totalRecordsSow = resp.an_total;
      this.loading = false;
      this.__spinnerService.close();
    });
  }

  onInputChangeSow(event: any) {
    this.searchSow.pageIndex = 0;
    this.searchSow.pageSize = 10;
    this.findListSow();
  }

  selectedSow(item: any) {
    this.selectedItemSow = item;
  }

  onAddNewSow() {
    let confirm = this.__dialogService.open(SowComponent, {
      width: '60%',
      header: 'New Sow',
      dismissableMask: false,
      closable: true,
      data: {
        item: {}
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      if (resp?.accion === 'success') {
        this.findListSow();
      }
    });
  }

  onEditNewSow() {
    if (this.isEmpty(this.selectedItemSow)) {
      return;
    }
    let confirm = this.__dialogService.open(SowComponent, {
      width: '60%',
      header: 'Edit Sow',
      dismissableMask: false,
      closable: true,
      data: {
        item: this.selectedItemSow
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      this.selectedItemSow = {};
      this.findListSow();
    });
  }

  onPageChangeSow(event: any) {
    this.searchSow.pageIndex = event.first / event.rows;
    this.searchSow.pageSize = event.rows;
    this.findListSow();
  }

  findListManualTimeSheet() {
    this.loading = true;
    this.__spinnerService.show({ type: 'dark' });
    this.manualTSList = [];
    let param = {
      pageSize: this.searchManualTS.pageSize,
      pageIndex: this.searchManualTS.pageIndex,
      filter: this.searchManualTS.filter !== null && this.searchManualTS.filter !== undefined ? this.searchManualTS.filter : ''
    }

    this.__manualTSService.getListManualTimeSheet(param).subscribe((resp: any) => {
      this.manualTSList = resp.listManualTS;
      this.totalRecordsManualTS = resp.an_total;
      this.loading = false;
      this.__spinnerService.close();
    });
  }

  onInputChangeManualTimeSheet(event: any) {
    this.searchManualTS.pageIndex = 0;
    this.searchManualTS.pageSize = 10;
    this.findListManualTimeSheet();
  }

  selectedManualTimeSheet(item: any) {
    this.selectedItemManualTS = item;
  }

  onAddNewManualTS() {
    let confirm = this.__dialogService.open(ManualTimeSheetComponent, {
      width: '60%',
      header: 'New Manual Time Sheet',
      dismissableMask: false,
      closable: true,
      data: {
        item: {}
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      if (resp?.accion === 'success') {
        this.findListManualTimeSheet();
      }
    });
  }

  onEditNewManualTS() {
    if (this.isEmpty(this.selectedItemManualTS)) {
      return;
    }
    let confirm = this.__dialogService.open(ManualTimeSheetComponent, {
      width: '60%',
      header: 'Edit Manual Time Sheet',
      dismissableMask: false,
      closable: true,
      data: {
        item: this.selectedItemManualTS
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      this.selectedItemManualTS = {};
      this.findListManualTimeSheet();
    });
  }

  onPageChangeManualTimeSheet(event: any) {
    this.searchManualTS.pageIndex = event.first / event.rows;
    this.searchManualTS.pageSize = event.rows;
    this.findListManualTimeSheet();
  }

  onInputChangeForecast(event: any) {
    this.searchForecast.pageIndex = 0;
    this.searchForecast.pageSize = 10;
    this.findListForecast();
  }

  selectedForecast(item: any) {
    this.selectedItemForecast = item;
  }

  onAddNewForecast() {
    let confirm = this.__dialogService.open(ForecastComponent, {
      width: '60%',
      header: 'New Forecast',
      dismissableMask: false,
      closable: true,
      data: {
        item: {}
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      if (resp?.accion === 'success') {
        this.findListForecast();
      }
    });
  }

  onEditForecast() {
    if (this.isEmpty(this.selectedItemForecast)) {
      return;
    }
    let confirm = this.__dialogService.open(ForecastComponent, {
      width: '60%',
      header: 'Edit Forecast',
      dismissableMask: false,
      closable: true,
      data: {
        item: this.selectedItemForecast
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      this.selectedItemForecast = {};
      this.findListForecast();
    });
  }

  onPageChangeForecast(event: any) {
    this.searchForecast.pageIndex = event.first / event.rows;
    this.searchForecast.pageSize = event.rows;
    this.findListForecast();
  }

  findListForecast() {
    this.loading = true;
    this.__spinnerService.show({ type: 'dark' });
    this.forecastList = [];
    let param = {
      pageSize: this.searchForecast.pageSize,
      pageIndex: this.searchForecast.pageIndex,
      filter: this.searchForecast.filter !== null && this.searchForecast.filter !== undefined ? this.searchForecast.filter : ''
    }

    this.__forecastService.getListForecast(param).subscribe((resp: any) => {
      this.forecastList = resp.listForecast;
      this.totalRecordsForecast = resp.an_total;
      this.loading = false;
      this.__spinnerService.close();
    });
  }

  onInputChangeReceipts(event: any) {
    this.searchReceipts.pageIndex = 0;
    this.searchReceipts.pageSize = 10;
    this.findListReceipts();
  }

  selectedReceipts(item: any) {
    this.selectedItemReceipts = item;
  }

  onAddNewReceipts() {
    let confirm = this.__dialogService.open(ReceiptsComponent, {
      width: '60%',
      header: 'New Receipts',
      dismissableMask: false,
      closable: true,
      data: {
        item: {}
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      if (resp?.accion === 'success') {
        this.findListReceipts();
      }
    });
  }

  onEditReceipts() {
    if (this.isEmpty(this.selectedItemReceipts)) {
      return;
    }
    let confirm = this.__dialogService.open(ReceiptsComponent, {
      width: '60%',
      header: 'Edit Receipts',
      dismissableMask: false,
      closable: true,
      data: {
        item: this.selectedItemReceipts
      }
    });

    confirm?.onClose.subscribe((resp: any) => {
      this.selectedItemReceipts = {};
      this.findListReceipts();
    });
  }

  onPageChangeReceipts(event: any) {
    this.searchReceipts.pageIndex = event.first / event.rows;
    this.searchReceipts.pageSize = event.rows;
    this.findListReceipts();
  }

  findListReceipts() {
    this.loading = true;
    this.__spinnerService.show({ type: 'dark' });
    this.receiptsList = [];
    let param = {
      pageSize: this.searchReceipts.pageSize,
      pageIndex: this.searchReceipts.pageIndex,
      filter: this.searchReceipts.filter !== null && this.searchReceipts.filter !== undefined ? this.searchReceipts.filter : ''
    }

    this.__receiptsService.getListReceipts(param).subscribe((resp: any) => {
      this.receiptsList = resp.listReceipts;
      this.totalRecordsReceipts = resp.an_total;
      this.loading = false;
      this.__spinnerService.close();
    });
  }

  onDownload(item: any) {
    this.__spinnerService.show({ type: 'dark' });
    this.__sowService.downloadFile( item.SOWID ).subscribe((resp: any) => {
      const base64 = resp.document;
      const fileBlob = DataURItoBlob(base64);
      const downloadlink = document.createElement('a');
      const filepath = window.URL.createObjectURL(fileBlob);
      downloadlink.href = filepath;
      downloadlink.setAttribute('download', item.FILENAME);
      document.body.appendChild(downloadlink);
      downloadlink.click();
      downloadlink.remove();
      this.__spinnerService.close();
    });
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  ngAfterViewInit(): void {
    $(".right-side-toggle").click(function () {
      $(".right-sidebar").slideDown(50), $(".right-sidebar").toggleClass("shw-rside")
    });
    $(".nav-lock").unbind();
    $(".nav-lock").on("click", function () {
      $("body").toggleClass("lock-nav"), $(".nav-lock i").toggleClass("mdi-toggle-switch-off"), $("body, .page-wrapper").trigger("resize")
    });
  }
}
